import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Dayjs from 'vue-dayjs'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import VueAffix from 'vue-affix'
import Vue2Filters from 'vue2-filters'
import VueFileAgent from 'vue-file-agent'
import VueClipboard from 'vue-clipboard2'
import { abilitiesPlugin } from '@casl/vue'
import ability from '@/plugins/ability'
import './plugins/vee-validate'
import '@/scss/main.scss'
import { VueMaskDirective } from 'v-mask'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

Vue.config.productionTip = false

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue,
    dsn: 'https://84d15994b984404da7d5ee2d15397d72@o228272.ingest.sentry.io/5658161',
    integrations: [new Integrations.BrowserTracing()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0
  })
}

dayjs.extend(customParseFormat)
dayjs.extend(relativeTime)

Vue.use(VueAffix)
Vue.use(Dayjs, {
  lang: 'en'
})
Vue.use(Vue2Filters)
Vue.directive('mask', VueMaskDirective)
Vue.use(VueFileAgent)
Vue.use(VueClipboard)
Vue.use(abilitiesPlugin, ability)

store.dispatch('getUser')

const vm = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

vm.$dayjs.extend(customParseFormat)
